/* Helper condivisi del Concierge AI: campi bilingui, foto, prezzi, split attività. */
import { API } from "@/api";
import { pick } from "@/i18n";

/* Split editoriale senza duplicati: queste categorie compaiono nella scheda
 * "Attività ed escursioni", le altre in "Esperienze". */
export const ACTIVITY_CATS = ["nature", "sea", "archeology", "family", "craft", "wellness"];
export const isActivity = (item) => item?.kind === "experience" && ACTIVITY_CATS.includes(item?.meta?.category);

export const svcName = (item, lang) => pick(item?.name, lang);
export const svcDesc = (item, lang) => pick(item?.desc, lang);
export const stopCity = (s, lang) => pick(s?.city, lang);
export const metaPick = (v, lang) => pick(v, lang);

/* Le foto degli snapshot sono path pubblici del sito (/api/public/...) o URL
 * assoluti (proxy gestionale / esterni): qui si normalizzano. */
export const absPhoto = (p) => (!p ? "" : p.startsWith("http") ? p : `${API}${p}`);

export const eur = (v) => `€ ${Number(v).toLocaleString("it-IT")}`;

/* Prezzo onesto: importo reale se noto, fascia Google per i ristoranti,
 * altrimenti «da preventivare». Mai inventato. */
export const priceLabel = (item, tc) => {
    if (item.price != null) return `${eur(item.price)}${item.price_type ? ` · ${item.price_type}` : ""}`;
    if (item?.meta?.price_level) return item.meta.price_level;
    return tc.priceQuote;
};

export const Stars = ({ rating, reviews }) => {
    if (!rating) return null;
    return (
        <span className="inline-flex items-center gap-1 text-amber-300" data-testid="svc-rating">
            {Array.from({ length: 5 }).map((_, i) => (
                <svg key={i} width="11" height="11" viewBox="0 0 24 24" fill={i < Math.round(rating) ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.6">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z" />
                </svg>
            ))}
            <span className="ml-1 text-[10px] text-stone-400">{rating}{reviews ? ` · ${reviews.toLocaleString("it-IT")}` : ""}</span>
        </span>
    );
};
